<template>
  <section class="section profile" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
        </div>
        <div class="contentSc">
          <div class="profilePict" v-if="avatar"
            :style="{'background-image': `url(${avatar})`}"></div>
          <div class="profilePict" v-else>
            <span v-if="name">{{name.substr(0, 2).toUpperCase()}}</span>
          </div>
          <div class="profileInfo">
            <h4>{{name}}</h4>
            <p>No. ABO: {{aboNo}}</p>
          </div>
          <div class="expCnt" v-on:click="openLevel">
            <h4>{{point.toLocaleString('id')}} point</h4>
            <div class="expLabel">dari 1.640pt</div>
            <div class="theExp">
              <div class="exp" :style="{width: `${point / 1640 * 100}%`}"></div>
            </div>
          </div>
          <div class="progressCnt" v-if="1>2">
            <h4>My workout progress</h4>
            <div class="theProgress">
              <div class="progressItem" v-for="i in 14" :key="i">
                <div class="progress" :style="{height: `${rand(60, 100)}%`}"></div>
                <div class="label">day <span>{{i}}</span></div>
              </div>
            </div>
          </div>
          <div class="menuCnt">
            <div class="menuItem" v-on:click="openEditProfile">
              <div class="menuIcon about"></div>
              Edit Profil
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="openAccount">
              <div class="menuIcon settings"></div>
              Pengaturan Akun
              <div class="more"></div>
            </div>
            <div class="divider"></div>
            <div class="menuItem" v-on:click="openReport"
              :class="{comingSoon: !completed}">
              <div class="menuIcon report"></div>
              Digital Report<div class="ntf" v-if="completed">new</div>
              <div class="comingSoon" v-if="!completed">Terbuka di hari ke-14</div>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="openBeforeAfter"
              :class="{comingSoon: !completed}">
              <div class="menuIcon beforeAfter"></div>
              Before After<div class="ntf" v-if="completed">new</div>
              <div class="comingSoon" v-if="!completed">Terbuka di hari ke-14</div>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="shareFinisher2"
              :class="{comingSoon: !completed}">
              <div class="menuIcon finisher"></div>
              Bagikan Finisher<div class="ntf" v-if="completed">new</div>
              <div class="comingSoon" v-if="!completed">Terbuka di hari ke-14</div>
              <div class="more"></div>
            </div>
            <div class="menuItem" v-on:click="openGalleri">
              <div class="menuIcon gallery"></div>
              Galeri Perubahan
              <div class="more"></div>
            </div>
            <div class="divider"></div>
            <a href="https://www.amway.id/id/privacy"
              target="_blank" class="menuItem">
              <div class="menuIcon link"></div>
              Pernyataan Kerahasiaan
            </a>
            <a href="https://nutrilite.co.id/bodykey/mulai-sekarang/syarat-ketentuan-bodykey-challenge"
              target="_blank" class="menuItem">
              <div class="menuIcon link"></div>
              Syarat Penggunaan
            </a>
            <div class="menuItem" v-on:click="feedback"
              :class="{comingSoon: !completed}">
              <div class="menuIcon feedback"></div>
              Saran &amp; Masukan<div class="ntf" v-if="completed">new</div>
              <div class="comingSoon" v-if="!completed">Terbuka di hari ke-14</div>
              <div class="more"></div>
            </div>
            <div class="divider"></div>
            <div class="menuItem logout" v-on:click="logout">
              <div class="menuIcon logout"></div>
              Keluar
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <DigitalReport ref="digitalReport"/>
    <BeforeAfter ref="beforeAfter"/>
    <EditProfile ref="editProfile"/>
    <EditAccount ref="editAccount"/>
    <Level ref="level"/>
    <PhotoHistory ref="photoHistory"/>
    <ShareFinisher2 ref="shareFinisher2"/>
    <Testimoni ref="testimoni"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import Level from '@/components/Level.vue';
import DigitalReport from '@/components/DigitalReport.vue';
import EditProfile from '@/components/EditProfile.vue';
import EditAccount from '@/components/EditAccount.vue';
import PhotoHistory from '@/components/PhotoHistory.vue';
import BeforeAfter from '@/components/BeforeAfter.vue';
import ShareFinisher2 from '@/components/ShareFinisher2.vue';
import Testimoni from '@/components/Testimoni.vue';

export default {
  name: 'home',
  components: {
    Confirmation,
    Level,
    DigitalReport,
    EditProfile,
    EditAccount,
    PhotoHistory,
    BeforeAfter,
    ShareFinisher2,
    Testimoni,
  },
  data() {
    return {
      aboNo: '. . .',
      point: 0,
      avatar: null,
      name: null,
      completed: false,
      show: false,
    };
  },
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.getData();
    },
    close() { this.show = false; },
    openEditProfile() { this.$refs.editProfile.open(); },
    openReport() {
      if (!this.completed) return;
      this.$refs.digitalReport.open();
    },
    openBeforeAfter() {
      if (!this.completed) return;
      this.$refs.beforeAfter.open();
    },
    openLevel() { this.$refs.level.open(); },
    openAccount() { this.$refs.editAccount.open(); },
    openGalleri() { this.$refs.photoHistory.open(); },
    shareFinisher2() {
      if (!this.completed) return;
      this.$refs.shareFinisher2.open();
    },
    feedback() {
      if (!this.completed) return;
      this.$refs.testimoni.open();
    },
    logout() {
      this.$refs.confirmDialog.open({
        title: 'Keluar',
        desc: 'Apakah kamu yakin ingin keluar? Kamu dapat masuk kembali kapan aja.',
        action: 'Keluar',
      }, (b) => {
        if (!b) return;
        this.$session.destroy();
        this.$router.push('/login');
      });
    },
    getData() {
      const d = new Date();
      const d2 = new Date();
      d2.setDate(15);
      d2.setMonth(5);
      d2.setFullYear(2023);
      d2.setHours(0);
      d2.setMinutes(0);
      this.completed = d.getTime() >= d2.getTime();
      this.name = this.$session.get('bk6_name');
      this.avatar = this.$session.get('bk6_avatar');
      this.point = this.$session.get('bk6_point') || 0;
      this.$http.get(this.$config.uri('user/abo/number')).then((r) => {
        this.aboNo = (r.data.status === 200) ? r.data.data : 'Unknown';
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.profile{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;

    background-color: #b7e4c9;
    background-image: linear-gradient(#fff 0, #e2fcec 50%, #fff);

    padding: 0 0 40px;
    box-sizing: border-box;
    width: 400px;
    z-index: 3;
    right: -400px;
    transition: all .45s ease;
    @media (max-width: 768px) {
      top: 60px;
    }
    @media (max-width: 680px) {
      width: 96%; right: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/high-five.png);
      background-size: auto 160px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    position: relative;
    padding: 5px 20px;
    z-index: 7;
    box-shadow: 0 0 4px rgba(0, 0, 0, .2);
    backdrop-filter: blur(20px);
    .backBtn{
      width: 40px; height: 40px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 24px;
      margin: 16px 0 14px;
      color: #006519;
    }
  }
  .contentSc{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    overflow-y: auto;
    z-index: 5;
    padding: 70px 10px 10px;
  }
  .profilePict{
    width: 94px; height: 94px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 auto 16px;
    background-position: center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .2);
    font-size: 32px;
    color: #fff;
    font-weight: 600;
  }
  .profileInfo{
    text-align: center;
    padding-bottom: 20px;
    h4{
      margin: 0;
      font-size: 20px;
    }
    p{
      margin: 0;
      font-size: 15px;
    }
  }
  .expCnt{
    background-color: rgba(255, 255, 255, .5);
    margin: 0 10px 10px;
    border-radius: 10px;
    padding: 16px 20px 20px;
    position: relative;
    transition: all .3s ease;
    cursor: pointer;
    &:hover{
      background-color: rgba(255, 255, 255, .8);
    }
    &:active{
      background-color: #ddd;
    }
    h4{
      margin: 0 0 6px;
      font-size: 16px;
    }
    .expLabel{
      position: absolute;
      right: 20px; top: 18px;
      font-size: 14px;
    }
    .theExp{
      height: 12px;
      background-color: #ccc;
      border-radius: 50px;
      .exp{
        height: 100%;
        background-color: #8EC642;
        // background-color: #6aa722;
        border-radius: 50px;
        max-width: 100%;
      }
    }
  }
  .progressCnt{
    background-color: rgba(255, 255, 255, .5);
    margin: 0 10px;
    border-radius: 10px;
    padding: 16px 20px 52px;
    h4{
      margin: 0 0 10px;
    }
    .theProgress{
      display: flex;
      height: 80px;
      justify-content: space-between;
      .progressItem{
        height: 100%;
        font-size: 10px;
        text-align: center;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        .label{
          position: absolute;
          left: 50%; margin-left: -15px;
          text-align: center;
          bottom: -34px;
          width: 30px;
          span{
            display: block;
            font-size: 14px;
            font-weight: bold;
            margin-top: -1px;
          }
        }
        .progress{
          width: 8px;
          background-color: #8EC642;
          background-color: #6aa722;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
    }
  }
  .menuCnt{
    padding: 20px 0 40px;
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 16px 20px;
      padding-left: 56px;
      font-weight: bold;
      display: block;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, .5);
      backdrop-filter: blur(20px);
      margin: 0 10px 6px;
      border-radius: 5px;
      font-size: 17px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: rgba(255, 255, 255, .8);
      }
      &:active{
        background-color: #ddd;
      }
      &.comingSoon{
        background-color: #bbb !important;
        cursor: default;
        .comingSoon{
          font-size: 14px;
          font-weight: 400;
          margin-bottom: -6px;
        }
      }
      .ntf{
        width: auto;
        min-width: 19px;
        height: 20px;
        background-color: red;
        border-radius: 10px;
        font-size: 12px;
        display: inline-block;
        margin: -6px 0 0 8px;
        text-align: center;
        // font-weight: bold;
        font-weight: 500;
        position: absolute;
        padding: 2px 5px;
        box-sizing: border-box;
        color: #fff;
      }
      .more{
        position: absolute;
        right: 12px; top: 16px;
        width: 20px; height: 20px;
        background-position: center;
        background-size: 16px auto;
        background-repeat: no-repeat;
        background-image: url(../assets/arrow-right-black.png);
        opacity: .3;
      }
      &.logout{
        color: #fe3126;
      }
      .menuIcon{
        position: absolute;
        left: 20px; top: 16px;
        width: 20px; height: 20px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        opacity: .9;
        &.report{
          background-image: url(../assets/report.png);
        }
        &.about{
          background-image: url(../assets/account.png);
        }
        &.settings{
          background-image: url(../assets/setting.png);
        }
        &.gallery{
          background-image: url(../assets/image-gallery.png);
        }
        &.link{
          background-image: url(../assets/foreign.png);
        }
        &.beforeAfter{
          background-image: url(../assets/before-after.png);
        }
        &.finisher{
          background-image: url(../assets/finish-flag.png);
        }
        &.feedback{
          background-image: url(../assets/feedback.png);
        }
        &.logout{
          background-image: url(../assets/logout-red.png);
        }
      }
    }
  }
}
</style>
